import { useEffect, useState } from 'react';
import { api, type Look, type Room } from '../../lib/api';

// The look a room wears on its stage (153): a rig or a scene from the Lab,
// drawn live with a real clock; the plate plays behind the boxes.
export function RoomLook({ room, brandId, onSave }: { room: Room; brandId: string | null; onSave: (lookId: string | null) => void }) {
  const [looks, setLooks] = useState<Look[]>([]);
  const [dressing, setDressing] = useState(false);
  const [note, setNote] = useState<string | null>(null);
  useEffect(() => { api.labLooks(brandId).then((ls) => setLooks(ls.filter((l) => l.kind !== 'plate' || l.status === 'ready'))).catch(() => setLooks([])); }, [brandId]);
  // T236: the director dresses a bare stage — the Town hall prototype in the
  // show's own colours, logo and handles, on the room at once (the rig is
  // drawn live), its plate made in the background for the next time.
  const dress = async () => {
    if (!brandId) return;
    setDressing(true); setNote(null);
    try {
      const look = await api.instantiatePrototype('town-hall', brandId);
      setLooks((ls) => [look, ...ls]);
      onSave(look.id);
      api.renderLook(look.id).then(() => setNote('On the stage now; the plate behind the boxes is being made.')).catch(() => setNote('On the stage now. Make the plate in the Lab when you want one behind the boxes.'));
    } catch (e) { setNote((e as Error).message); } finally { setDressing(false); }
  };
  return (
    <div className="row" style={{ gap: 8, alignItems: 'center', margin: '8px 0' }} data-tool="room-look" data-move="live-look">
      <span className="sub-dim">The look on the stage:</span>
      <select value={room.look_id ?? ''} onChange={(e) => onSave(e.target.value || null)} aria-label="Look">
        <option value="">none — the plain stage</option>
        {looks.map((l) => <option key={l.id} value={l.id}>{l.name} · {l.kind}{l.status === 'ready' ? '' : ' (draft)'}</option>)}
      </select>
      {!room.look_id && brandId && <button type="button" className="btn tiny pri" disabled={dressing} data-tool="dress-stage" onClick={() => void dress()} title="A Town hall look in the show's colours, with its logo and handles, on this stage now">{dressing ? 'Dressing…' : 'Let the director dress it'}</button>}
      <span className="sub-dim">{note ?? 'the rig is drawn live with a real clock; a made plate plays behind the boxes'}</span>
    </div>
  );
}
